import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { iconStyles } from '../styles/icons.js';

@customElement('hg-icon-button')
export class HgIconButton extends LitElement {
  static styles = [
    iconStyles,
    css`
    :host {
      display: inline-flex;
    }
    button,
    a {
      width: 2.75rem;
      height: 2.75rem;
      border: 0;
      border-radius: 50%;
      display: grid;
      place-items: center;
      background: transparent;
      color: inherit;
      cursor: pointer;
      text-decoration: none;
      transition: background var(--md-sys-motion);
    }
    button:hover,
    a:hover {
      background: color-mix(in srgb, currentColor 8%, transparent);
    }
    .material-symbols-outlined {
      font-size: 1.45rem;
    }
  `,
  ];

  @property() icon = 'menu';
  @property() label = '';
  @property() href?: string;

  render() {
    const inner = html`<span class="material-symbols-outlined" aria-hidden="true">${this.icon}</span>`;
    if (this.href) {
      return html`<a href=${this.href} aria-label=${this.label}>${inner}</a>`;
    }
    return html`<button type="button" aria-label=${this.label}>${inner}</button>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'hg-icon-button': HgIconButton;
  }
}
